var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { get } from "lodash";
import { Col } from "react-bootstrap";
import { connect } from "@irati/store";
import Validation, { ValidationInput } from "@irati/utils/validation";
import { FormGroup } from "@irati/ui/src/Form";
import ErrorText from "@irati/ui/src/ErrorText";
import id from "@irati/utils/id";
import { FormattedMessage, getResolvedMessage, injectIntl } from "@irati/utils/lang";
import TrophiesQuery from "@irati/recognition/apollo/query/Trophies";
import addTrophy from "@irati/ui/images/trophy-empty.png";
import TrophyImg from "@irati/ui/src/Trophy";
import Close from "@irati/ui/src/Close";
import InlineTrophySlider from "./InlineTrophy";
import { ComponentToHideOnExpandContainer, FlexRow, Label, Text, TextButton, TrophyContainer, TrophyWrapper, Wrapper } from "./styled";
import { TROPHY_SIZE, DEFAULT_WIDTH_OF_TROPHY_SLIDER, PROPERTY } from "./constants";
export var schema = Validation.string("platform.defaultValidation.required");
var TrophyPicker = /** @class */ (function (_super) {
    __extends(TrophyPicker, _super);
    function TrophyPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.validation = new ValidationInput(_this);
        _this.getTrophy = function (challenge) {
            var trophy = challenge.trophy;
            return get(trophy, "href");
        };
        _this.handleButtonClick = function (isTrophySelected) {
            if (isTrophySelected === void 0) { isTrophySelected = true; }
            _this.setState({ isTrophySelected: isTrophySelected, errorMsg: undefined });
        };
        _this.handleTrophySelect = function (trophy) {
            _this.setState({
                isTrophySelected: false,
                errorMsg: undefined,
                value: get(trophy, "href")
            });
            _this.props.onChange(trophy);
        };
        _this.setError = function (errorMsg) {
            _this.setState({ errorMsg: errorMsg });
        };
        _this.state = {
            isTrophySelected: false,
            value: _this.getTrophy(props.item)
        };
        return _this;
    }
    TrophyPicker.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    TrophyPicker.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    TrophyPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, isPhone = _a.isPhone, componentToHideOnExpand = _a.componentToHideOnExpand, sliderWidth = _a.sliderWidth;
        var _b = this.state, value = _b.value, errorMsg = _b.errorMsg, isTrophySelected = _b.isTrophySelected;
        var showTrophySelector = isTrophySelected || isPhone;
        return (React.createElement(FlexRow, null,
            React.createElement(ComponentToHideOnExpandContainer, { isTrophySelected: showTrophySelector }, componentToHideOnExpand()),
            React.createElement(TrophyWrapper, { isTrophySelected: showTrophySelector },
                React.createElement(TrophyContainer, { isTrophySelected: showTrophySelector },
                    React.createElement(FormGroup, null,
                        React.createElement(Col, { xs: 12 },
                            React.createElement(Label, { error: errorMsg }, getResolvedMessage(this, "label")),
                            isTrophySelected && React.createElement(Close, { right: "15px", onClick: function () { return _this.handleButtonClick(false); } })),
                        React.createElement(Col, { xs: 12 },
                            React.createElement(Wrapper, { isTrophySelected: showTrophySelector, error: !!errorMsg },
                                React.createElement(TrophiesQuery, null, function (_a) {
                                    var trophies = _a.data.trophies;
                                    return (React.createElement(InlineTrophySlider, { updateError: _this.setError, show: showTrophySelector, item: item, onChange: _this.handleTrophySelect, sliderWidth: sliderWidth, trophies: trophies.results }));
                                }),
                                !showTrophySelector &&
                                    React.createElement(TextButton, { id: id(PROPERTY + "_addBtn", this.props), inline: false, onClick: function () { return _this.handleButtonClick(true); } },
                                        React.createElement(TrophyImg, { src: value || addTrophy, size: TROPHY_SIZE - 20 + "px", isSet: !!value }),
                                        !value && React.createElement(Text, { size: TROPHY_SIZE },
                                            React.createElement(FormattedMessage, { id: "platform.fields.trophy.text" }))),
                                errorMsg && React.createElement("div", null,
                                    React.createElement(ErrorText, { id: id("trophyCopyError", this.props), small: true }, getResolvedMessage(this, "errorMsg", this.state))))))))));
    };
    TrophyPicker.defaultProps = {
        id: "itemContainingTrophy",
        label: "platform.fields.poll.trophy.label",
        sliderWidth: DEFAULT_WIDTH_OF_TROPHY_SLIDER,
        validation: schema
    };
    return TrophyPicker;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isPhone: get(mq, "lessThan.medium", false)
    });
};
export default injectIntl(connect(mapStateToProps)(TrophyPicker));
